import { LocaleCompatibility } from '../localization/LocaleCompatibility'
import { Errors } from './logger/Errors'
import { Log } from './logger/Log'

export class LocalizationActivity {
  private start: number
  private desiredLocale: string
  private matchedLocale: string
  private compatibility: LocaleCompatibility

  constructor(desiredLocale: string, matchedLocale: string, compatibility: LocaleCompatibility) {
    this.start = Date.now()
    this.desiredLocale = desiredLocale
    this.matchedLocale = matchedLocale
    this.compatibility = compatibility
  }

  public finishWithSuccess(): void {
    Log.logger.logReportData('LocalizationActivity', false /* isCriticalEvent */, {
      'Success': true,
      'SuccessRate': 1,
      'Duration': Date.now() - this.start,
      'DesiredLocale': this.desiredLocale,
      'MatchedLocale': this.matchedLocale,
      'Compatibility': LocaleCompatibility[this.compatibility],
    })
  }

  public finishWithFailure(errorBucket: string, error?: Error): void {
    Log.logger.logReportData('LocalizationActivity', false /* isCriticalEvent */, {
      'Success': false,
      'SuccessRate': 0,
      'DesiredLocale': this.desiredLocale,
      'MatchedLocale': this.matchedLocale,
    } /* payloadNonPII */, {
      'ErrorName': error ? error.name : '',
      'Duration': Date.now() - this.start,
      'ErrorMessage': error ? error.message : '',
      'ErrorBucket': errorBucket,
      'Compatibility': LocaleCompatibility[this.compatibility],
    })

    Log.logger.logUnexpected(Errors.getLocalizationActivityError(errorBucket), errorBucket)
  }
}
